import { Link } from 'react-router-dom';
import { ExportOutlined } from '@ant-design/icons';
import { Routes } from 'router/routes';

import s from './PatientCell.module.scss';

import type { FC } from 'react';

interface IPatientCellProps {
  patientGuid: string;
  patientName: string;
}

const PatientCell: FC<IPatientCellProps> = ({ patientGuid, patientName }) => {
  return (
    <Link
      to={Routes.patientGuid(patientGuid)}
      className={s['patient-link']}
      target="_blank"
      data-cy="patient-cell-link"
    >
      {patientName} <ExportOutlined className={s['external-icon']} />
    </Link>
  );
};

export default PatientCell;
